<template>
    <li
        v-if="editMode || !channel.is_hidden"
        :id="channelGroupId"
        :class="{'dim': editMode && channel.is_hidden}"
        :data-cid="channel.id"
        class="channel"
    >
        <div v-if="!channel.is_protected && !editMode">
            <div
                v-if="channel.is_favorite"
                class="channel_favorite-icon active"
            >
                <a
                    href="#"
                    title="Удалить из избранного"
                    @click.prevent="removeFromFavorites(channel)"
                >
                    <img src="dist/star-active.svg">
                </a>
            </div>
            <div
                v-else
                class="channel_favorite-icon"
            >
                <a
                    href="#"
                    title="Добавить в избранное"
                    @click.prevent="addToFavorites(channel)"
                >
                    <img src="dist/star.svg">
                </a>
            </div>
        </div>
        <div
            @click="openChannel"
            class="channel_body"
            :class="{'disabled': editMode}"
        >
            <div class="channel_image">
                <img :src="channel.icon">
            </div>
            <div class="channel_info">
                <div class="name">{{ channel.name }}</div>
                <div
                    class="programm"
                    :title="channel.epg_progname"
                >{{ channel.epg_progname }}</div>
                <div
                    class="time"
                    v-show="channel.epg_start"
                >
                    <div class="start">{{ channel.epg_start | time }}</div>
                    <div class="progress">
                        <div :style="{ 'width' : progress + '%' }"></div>
                    </div>
                    <div class="end">{{ channel.epg_end | time }}</div>
                </div>
            </div>
        </div>
        <div
            v-show="channel.archive && !editMode"
            title="Открыть архив"
            class="channel_right-button"
            @click="showEpg"
        >
            <i class="icon-clock"></i>
        </div>

        <div
            v-show="editMode && !channel.is_hidden"
            title="Скрыть канал"
            class="channel_right-button hide-channel-button"
            @click="hideChannel(channel)"
        >
            <i class="icon-eye"></i>
        </div>

        <div
            v-show="editMode && channel.is_hidden"
            title="Показывать канал"
            class="channel_right-button show-channel-button"
            @click="showChannel(channel)"
        >
            <i class="icon-eye"></i>
        </div>
    </li>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
    props: ["channel", "serverOffset", "channelGroupId", "editMode"],
    data() {
        return {
            progress: 0
        };
    },
    computed: {
        ...mapState({
            timeshiftValue: state => state.login.account.settings.timeshift.value
        })
    },
    methods: {
        ...mapActions([
            "addToFavorites",
            "removeFromFavorites",
            "getEpg",
            "setEpgChannel"
        ]),
        hideChannel(channel) {
            this.$emit("hideChannel", channel);
        },
        showChannel(channel) {
            this.$emit("showChannel", channel);
        },
        openChannel() {
            this.$emit("openChannel", this.channel);
        },
        showEpg() {
            this.setEpgChannel(this.channel).then(() => {
                this.getEpg();
            });
        },
        calcProgress() {
            let now = Math.trunc((Date.now() - (this.timeshiftValue * 60 * 60 * 1000)) / 1000);
            this.progress = Math.trunc(
                ((now - this.channel.epg_start) /
                    (this.channel.epg_end - this.channel.epg_start)) *
                    100
            );
            if (this.progress >= 100) this.$emit("apiGetChannelList");
        }
    },
    filters: {
        time(v) {
            let time = new Date(v * 1000); // Todo: добавить сдвиг относительно сервера
            return (
                time.getHours() +
                ":" +
                (time.getMinutes() < 10
                    ? "0" + time.getMinutes()
                    : time.getMinutes())
            );
        }
    },
    created() {
        this.calcProgress();
        window.setInterval(() => {
            this.calcProgress();
        }, 5000);
    }
};
</script>
<style>
#channellist .channel {
    border-bottom: solid 1px rgba(255, 255, 255, 0.1);
    border-right: solid 1px rgba(255, 255, 255, 0.1);
    height: 120px;
    position: relative;
    cursor: pointer;
}

.channel .channel_body {
    padding: 20px;
    margin-right: 50px;
    height: 80px;
}

.channel .channel_body:hover {
    background-color: rgba(0, 0, 0, 0.75);
}

.channel .name {
    font-size: 21px;
}

.channel .channel_image {
    height: 80px;
    width: 80px;
    margin-top: 20px;
    margin-right: 20px;
    float: left;
}

.channel .channel_image img {
    /*width: 80px;*/
    /*margin-top: 20px;*/
    /*margin-right: 20px;*/
    /*float: left;*/
    width: 100%;
}

.channel .channel_right-button {
    position: absolute;
    top: 0px;
    bottom: 0;
    right: 0px;
    /*right: -50px;*/
    width: 50px;
    font-size: 32px;
    /* color: #00b200; */
    /* margin: auto; */
    /* height: 100%; */
    padding-top: 45px;
    text-align: center;
    cursor: pointer;
    /*background-color: rgba(0, 0, 0, .3);*/
}

.channel .channel_right-button:hover {
    /*background-color: rgba(255, 255, 255, .3);*/
    /*color: #000;*/
    background-color: rgba(0, 0, 0, 0.75);
}

.channel .programm {
    color: #dedede;
    font-size: 12px;
    line-height: 14px;
    min-height: 28px;
    height: 28px;
    overflow: hidden;
    margin: 0 0 8px;
    /*transition: height 2s ease;*/
}

.channel .time {
    font-size: 10px;
    line-height: 10px;
    height: 17px;
    overflow: hidden;
    position: relative;
}

.channel .time .start,
.channel .time .end {
    width: 40px;
    float: left;
    position: absolute;
    top: 4px;
    left: 2px;
    color: #eeac32;
}

.channel .time .end {
    left: auto;
    right: 2px;
    text-align: right;
}

.channel .time .progress {
    margin: 5px 40px 0;
    background: #555;
    height: 6px;
    border-radius: 2px;
    overflow: hidden;
}

.channel .time .progress > div {
    width: 50%;
    height: 6px;
    border-radius: 2px;
    background: #eeac32;
    background: linear-gradient(
        to top,
        rgba(238, 172, 50, 0.5),
        rgba(238, 172, 50, 1)
    );
}

.channel_favorite-icon {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 99;
    width: 16px;
}

.channel_favorite-icon.active i {
    color: #ffc107;
}

.channel_favorite-icon img {
    width: 100%;
    /* height: 100%; */
}

.channel_favorite-icon a {
    text-decoration: none;
}

.icon-hidden:after {
    content: "";
    display: block;
    position: absolute;
    width: 80%;
    height: 1px;
    background: #fff;
    transform: rotate(-45deg);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// Channel.vue?228f2cf4